import { formatDuration, intervalToDuration } from "date-fns";
import { formatInTimeZone } from "date-fns-tz";

export const millisecondsToDuration = (ms) => {
    const duration = intervalToDuration({ start: 0, end: ms });
    return {
        hours: duration.hours || 0,
        minutes: duration.minutes || 0,
        seconds: duration.seconds || 0
    };
};

const formatDistanceLocale = {
    xSeconds: "{{count}}",
    xMinutes: "{{count}}",
    xHours: "{{count}}"
};

const shortEnLocale = {
    formatDistance: (token, count) => {
        return formatDistanceLocale[token].replace(
            "{{count}}",
            count.toString().padStart(2, "0")
        );
    }
};

export const formatMilliseconds = (ms, format = ["minutes", "seconds"]) => {
    const duration = millisecondsToDuration(ms);

    return formatDuration(duration, {
        delimiter: ":",
        zero: true,
        format,
        locale: shortEnLocale
    });
};

export const formatDateTime = (
    date,
    tz = "America/New_York",
    format = "MM/dd/yyyy"
) => {
    return formatInTimeZone(date, tz, format);
};

export const formatDateInTimeZone = (date) => {
    return formatDateTime(date);
};

export const formatTimeInTimeZone = (date) => {
    return formatDateTime(date, "America/New_York", "hh:mm a zzz");
};

const toMilliseconds = (hours, minutes, seconds) => {
    return (hours * 60 * 60 + minutes * 60 + seconds) * 1000;
};

export const isBefore7PM = (date) => {
    const time = formatDateTime(date, "America/New_York", "HH:mm:ss");
    const [hh, mm, ss] = time.split(":").map(Number);
    const milliseconds = toMilliseconds(hh, mm, ss);
    const sevenPM = toMilliseconds(19, 0, 0); // 7 PM in milliseconds

    return milliseconds < sevenPM;
};

/**
 * Convert a formatted duration to equivalent seconds
 * @param {string} duration
 * @returns {number}
 */
export const durationToSeconds = (duration = "00:00:00") => {
    const durationArr = duration
        .split(":")
        .map((v) => Number(v))
        .reverse();

    return (
        toMilliseconds(
            durationArr[2] || 0,
            durationArr[1] || 0,
            durationArr[0] || 0
        ) / 1000
    );
};
